import { render, staticRenderFns } from "./InspeccionesTerminadas.vue?vue&type=template&id=74198721&"
import script from "./InspeccionesTerminadas.vue?vue&type=script&lang=js&"
export * from "./InspeccionesTerminadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports